import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    imports: [NgIf],
    standalone: true,
})
export class ButtonComponent {
    @Input() label: string = 'Submit';
    @Input() type: 'submit' | 'button' = 'button';
    @Input() disabled = false;
    @Input() context: 'upload' | 'default' | 'none' = 'default';
    @Input() minWidth: string = '10rem';
    @Input() bgcolor: string = '#404040';

    @Output() clicked = new EventEmitter<void>();

    onClick() {
        this.clicked.emit();
    }
}
